import { togglePropertiesId } from '@store/debugger';

export function triggerPropertiesId() {
    togglePropertiesId();
    window.location.reload();
}
